import { useState, useEffect } from "react";
import AdminTabs from "../adminTabs";
import { ThreeCircles } from "react-loader-spinner";
import "./corporateLeads.css";
import GetAPI from "../../APICalls/GetQuery";
import PutAPI from "../../APICalls/PutAPI";
import RenderTabContent from "./renderTabContent";

const TABS = ["Leads", "Contacted", "Dropped"];

const CorporateLeads = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Leads");
  const [activeData, setActiveData] = useState([]);

  let environment = process.env.REACT_APP_NODE_ENV;
  let corporateApi;
  if (environment.toUpperCase() === "PRODUCTION") {
    corporateApi = process.env.REACT_APP_PROD_CORPORATE;
  } else {
    corporateApi = process.env.REACT_APP_DEV_CORPORATE;
  }

  const getCorporateDataViaStatus = () => {
    const QUERY_PARAMS = { status: activeTab }
    GetAPI(corporateApi, QUERY_PARAMS)
      .then((res) => {
        if (res && res.data && res.data.statusCode === 200) {
          setActiveData(res.data.body);
        } else {
          alert("Failed to get data");
          console.log(res);
        }
      })
      .catch((e) => {
        console.error(e);
        alert("Failed to get data");
      });
  };

  useEffect(() => {
    getCorporateDataViaStatus(activeTab);
  }, [activeTab]);

  const handleActionClick = (action, lead) => {
    const confirmText = `Are you sure you want to move ${lead.companyName} to ${action}?`;
    const confirmed = window.confirm(confirmText);

    if (!confirmed) return;
    setLoading(true);
    const updatedData = {
      status: action,
      userID: lead.userID,
    };

    PutAPI(corporateApi, updatedData)
      .then((res) => {
        setLoading(false);
        if (res.data.statusCode === 200) {
          alert("Successfully updated!");
          getCorporateDataViaStatus();
        } else {
          alert("Failed to update.");
        }
      })
      .catch((e) => {
        setLoading(false);

        console.error(e);
        alert("Failed to update.");
      });
  };

  const handleCommentSave = (lead, comment) => {
  const confirmText = `Are you sure you want to update the comment for ${lead.companyName}?`;
  const confirmed = window.confirm(confirmText);

  if (!confirmed) return;
  setLoading(true);

  const updatedData = {
    comments: comment,
    userID: lead.userID,
  };

  PutAPI(corporateApi, updatedData)
    .then((res) => {
      setLoading(false);
      if (res.data.statusCode === 200) {
        alert("Comment successfully updated!");
        getCorporateDataViaStatus(); 
      } else {
        alert("Failed to update comment.");
      }
    })
    .catch((e) => {
      setLoading(false);
      console.error(e);
      alert("Failed to update comment.");
    });
};


  useEffect(() => {
    const savedTab = localStorage.getItem("corporateLeadsTab");
    if (savedTab && TABS.includes(savedTab)) {
      setActiveTab(savedTab);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("corporateLeadsTab", activeTab);
  }, [activeTab]);

  return (
      <AdminTabs >
      {loading ? (
        <div className="spinnerContainer">
          <div className="spinner">
            <ThreeCircles
              color="blue"
              height={110}
              width={110}
              ariaLabel="three-circles-rotating"
            />
          </div>
        </div>
      ) : (
        <div className="screen">
          <ul className="nav nav-tabs">
            {TABS.map((tab) => (
              <li className="nav-item" key={tab}>
                <a
                  className={`nav-link ${
                    activeTab === tab ? "custom-active-tab" : ""
                  }`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab(tab);
                  }}
                >
                  {tab}
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-3">
            <RenderTabContent
              activeData={activeData}
              handleActionClick={handleActionClick}
              activeTab={activeTab}
              handleCommentSave={handleCommentSave}
            />
          </div>
        </div>
      )}
      </AdminTabs>
  );
};

export default CorporateLeads;
